import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { Hash, Calendar, AlertTriangle, CheckCircle } from "lucide-react";

export function CustomerSerialNumbers({ serialNumbers, customerId }) {
  const getExpiryStatus = (date) => {
    if (!date) return null;
    const expiry = new Date(date);
    const now = new Date();
    const daysUntil = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
    if (daysUntil < 0) return "expired";
    if (daysUntil <= 30) return "expiring";
    return "valid";
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Seriennummern</CardTitle>
          <CardDescription>Geräte bei diesem Kunden</CardDescription>
        </div>
        <Button size="sm" asChild>
          <Link to={`/serial-numbers?customer=${customerId}`} data-testid="view-serials-btn">
            <Hash className="w-4 h-4 mr-2" />
            Verwalten
          </Link>
        </Button>
      </CardHeader>
      <CardContent>
        {serialNumbers.length > 0 ? (
          <div className="space-y-3">
            {serialNumbers.map((serial) => {
              const status = getExpiryStatus(serial.expiry_date);
              return (
                <div key={serial.id} className="flex items-center justify-between p-4 rounded-lg bg-muted/50">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <Hash className="w-5 h-5 text-primary" />
                    </div>
                    <div>
                      <p className="font-medium">{serial.serial_number}</p>
                      <p className="text-sm text-muted-foreground">{serial.product_name}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {serial.expiry_date && (
                      <Badge variant={status === "expired" ? "destructive" : status === "expiring" ? "warning" : "outline"}>
                        {status === "expired" && <AlertTriangle className="w-3 h-3 mr-1" />}
                        {status === "valid" && <CheckCircle className="w-3 h-3 mr-1" />}
                        <Calendar className="w-3 h-3 mr-1" />
                        {new Date(serial.expiry_date).toLocaleDateString("de-DE")}
                      </Badge>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="empty-state py-8">
            <Hash className="w-12 h-12 text-muted-foreground/30" />
            <p className="text-muted-foreground mt-4">Keine Seriennummern hinterlegt</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
